// src/routes/_org/org/portal/dashboard.tsx
import { createFileRoute } from '@tanstack/react-router';

import { DashboardPage } from '@/features/org-analytics/pages/DashboardPage';

export const Route = createFileRoute('/_org/org/portal/dashboard')({
  component: DashboardPage,
});
